import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_BUILDING_HEAT_TO_ELECTRICAL_ENERGY',
  CREATE: 'ADD_BUILDING_HEAT_TO_ELECTRICAL_ENERGY',
  EDIT: 'EDIT_BUILDING_HEAT_TO_ELECTRICAL_ENERGY',
  DELETE: 'DELETE_BUILDING_HEAT_TO_ELECTRICAL_ENERGY',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT',
};

export const listHeatToElectricalEnergyInBuilding = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_HEAT_TO_ELECTRICAL_ENERGY,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
        building_id: buildingId,
      }
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addHeatToElectricalEnergyToBuilding = (heatToElectricalEnergyId, buildingId, quantity, azimuth, inclination) => {
  const data = {
    heat_to_electrical_id: heatToElectricalEnergyId,
    building_id: buildingId,
    quantity: quantity,
    azimuth_angle: azimuth,
    inclination,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_HEAT_TO_ELECTRICAL_ENERGY,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editHeatToElectricalEnergyInBuilding = (buildingHeatToElectricalEnergyId, quantity, azimuth, inclination) => {
  const data = {
    quantity,
    azimuth_angle: azimuth,
    inclination,
  };

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_PROJECT_HEAT_TO_ELECTRICAL_ENERGY}${buildingHeatToElectricalEnergyId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeHeatToElectricalEnergyFromBuilding = (buildingHeatToElectricalEnergyId, buildingId) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT_HEAT_TO_ELECTRICAL_ENERGY}${buildingHeatToElectricalEnergyId}/`,
    })
      .then(() => ({ id: buildingHeatToElectricalEnergyId, building_id: buildingId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/projects/project_heat_to_electrical_energy_actions.js